import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  status: 'not connected',
  error: null
}

const messagingSocketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    connect: state => {
      state.status = 'connected'
      state.error = null
    },
    disconnect: state => {
      state.status = 'disconnected'
    },
    destroy: state => {
      state.status = 'not connected'
    },
    gotError: (state, action) => {
      state.status = 'disconnected'
      state.error = action.payload
    }
  }
})

export default messagingSocketSlice
